import { useSyncExternalStore } from 'react';
import { subscribeToMobileConfig } from '@/services/configService';
import type { MobileConfig } from '@/types';

let cache: MobileConfig | null = null;
let listeners = new Set<() => void>();
let unsub: (() => void) | null = null;

function subscribe(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  if (listeners.size === 1) {
    unsub = subscribeToMobileConfig((config) => {
      cache = config;
      listeners.forEach(l => l());
    });
  }
  return () => {
    listeners.delete(onStoreChange);
    if (listeners.size === 0 && unsub) {
      unsub();
      unsub = null;
    }
  };
}

function getSnapshot(): MobileConfig | null {
  return cache;
}

export function useMobileConfig(): MobileConfig | null {
  return useSyncExternalStore(subscribe, getSnapshot);
}
